import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchEvents } from '../services/api';
import './Events.css';

export const CATEGORY_EMOJI = {
  Celebration: '🎊',
  Health: '🩺',
  Environment: '🌳',
  Meeting: '🤝',
  Welfare: '🍱',
};

const categories = ['All', 'Celebration', 'Health', 'Environment', 'Meeting', 'Welfare'];

function formatDate(value) {
  if (!value) return '';
  return new Date(value).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function Events() {
  const [tab, setTab] = useState('upcoming');
  const [category, setCategory] = useState('All');
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchEvents()
      .then((data) => { if (!cancelled) setEvents(data || []); })
      .catch(() => { if (!cancelled) setEvents([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const filtered = events.filter((e) => {
    const matchTab = e.isUpcoming === (tab === 'upcoming');
    const matchCat = category === 'All' || e.category === category;
    return matchTab && matchCat;
  });

  return (
    <div className="events-page">
      <div className="page-hero">
        <div className="container">
          <div className="badge">Community</div>
          <h1>Events & Social Activities</h1>
          <p>Celebrations, health camps, environmental drives and community welfare — Aarambh brings Valsad together.</p>
        </div>
      </div>

      <section>
        <div className="container">
          {/* Tabs */}
          <div className="events-tabs">
            <button className={`tab-btn${tab === 'upcoming' ? ' active' : ''}`} onClick={() => setTab('upcoming')}>
              🗓 Upcoming Events
            </button>
            <button className={`tab-btn${tab === 'past' ? ' active' : ''}`} onClick={() => setTab('past')}>
              📅 Past Events
            </button>
          </div>

          {/* Category Filter */}
          <div className="category-filter">
            {categories.map((c) => (
              <button
                key={c}
                className={`cat-btn${category === c ? ' active' : ''}`}
                onClick={() => setCategory(c)}
              >
                {c}
              </button>
            ))}
          </div>

          {/* Events Grid */}
          {loading ? (
            <div className="no-results">
              <div style={{ fontSize: '3rem' }}>⏳</div>
              <h3>Loading events...</h3>
            </div>
          ) : (
            <>
              <div className="events-grid">
                {filtered.map((ev) => (
                  <div key={ev.id} className="event-card card">
                    <div className="event-card-top">
                      <div className="event-emoji">{CATEGORY_EMOJI[ev.category] || '🎉'}</div>
                      <span className={`event-status-badge ${ev.isUpcoming ? 'upcoming' : 'past'}`}>
                        {ev.isUpcoming ? '🟢 Upcoming' : '✅ Completed'}
                      </span>
                    </div>
                    {ev.category && <div className="event-cat-tag">{ev.category}</div>}
                    <h3>{ev.title}</h3>
                    <div className="event-details">
                      <div className="event-detail">📅 {formatDate(ev.date)}</div>
                      {ev.time && <div className="event-detail">⏰ {ev.time}</div>}
                      {ev.location && <div className="event-detail">📍 {ev.location}</div>}
                    </div>
                    <div className="event-card-actions">
                      <Link to={`/events/${ev.id}`} className="btn-outline">
                        View Event
                      </Link>
                    </div>
                  </div>
                ))}
              </div>

              {filtered.length === 0 && (
                <div className="no-results">
                  <div style={{ fontSize: '3rem' }}>📭</div>
                  <h3>No events found</h3>
                  <p>Check back soon or try a different category.</p>
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {/* Propose Activity */}
      <section className="propose-section">
        <div className="container propose-inner">
          <div className="propose-text">
            <div className="badge">Get Involved</div>
            <h2>Want to Organise a Social Activity?</h2>
            <p>If your mandal wants to host a blood donation camp, cleanliness drive or any community welfare activity, reach out and we will support you with coordination, volunteers and resources.</p>
          </div>
          <Link to="/contact" className="btn-primary" style={{ flexShrink: 0 }}>Propose an Activity</Link>
        </div>
      </section>
    </div>
  );
}
